// extracted by mini-css-extract-plugin
module.exports = {"Error_message":"Error_message__Error_message--VffQD"};